import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _dd2b52f8 = () => import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */).then(m => m.default || m)
const _30c56b74 = () => import('../pages/download-data/index.vue' /* webpackChunkName: "pages/download-data/index" */).then(m => m.default || m)
const _7cb4fdcd = () => import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */).then(m => m.default || m)
const _38da60d6 = () => import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */).then(m => m.default || m)
const _2a920e22 = () => import('../pages/research-briefs/index.vue' /* webpackChunkName: "pages/research-briefs/index" */).then(m => m.default || m)
const _e4cbf886 = () => import('../pages/teaching-toolkit/index.vue' /* webpackChunkName: "pages/teaching-toolkit/index" */).then(m => m.default || m)
const _00f5f347 = () => import('../pages/country/_countryID.vue' /* webpackChunkName: "pages/country/_countryID" */).then(m => m.default || m)
const _4878bcf2 = () => import('../pages/dataset/_datasetID.vue' /* webpackChunkName: "pages/dataset/_datasetID" */).then(m => m.default || m)
const _482400f4 = () => import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)



if (process.client) {
  window.history.scrollRestoration = 'manual'
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected
  if (to.matched.length < 2) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/about",
			component: _dd2b52f8,
			name: "about"
		},
		{
			path: "/download-data",
			component: _30c56b74,
			name: "download-data"
		},
		{
			path: "/faq",
			component: _7cb4fdcd,
			name: "faq"
		},
		{
			path: "/privacy-policy",
			component: _38da60d6,
			name: "privacy-policy"
		},
		{
			path: "/research-briefs",
			component: _2a920e22,
			name: "research-briefs"
		},
		{
			path: "/teaching-toolkit",
			component: _e4cbf886,
			name: "teaching-toolkit"
		},
		{
			path: "/country/:countryID?",
			component: _00f5f347,
			name: "country-countryID"
		},
		{
			path: "/dataset/:datasetID?",
			component: _4878bcf2,
			name: "dataset-datasetID"
		},
		{
			path: "/",
			component: _482400f4,
			name: "index"
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js